/* global axios */
import ApiClient from './ApiClient';

class DescriptionAPI extends ApiClient {
  constructor() {
    super('description', { accountScoped: true });
  }

  show(id, { locale } = {}) {
    const isInsideAccount = window.location.pathname.includes('/app/accounts');

    // On the public login page there is no account context. Use the dedicated
    // public login_page endpoint and forward the user-selected locale.
    if (!isInsideAccount && id === 'login_page') {
      return axios.get('/api/v1/login_page', { params: { locale } });
    }

    return axios.get(`${this.url}`, { params: { descr_key: id } });
  }
}

export default new DescriptionAPI();
